import { SVGProps } from 'react';

const Vault = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m7.9 7.9 2.7 2.7m2.8 0 2.7-2.7m-8.2 8.2 2.7-2.7m2.8 0 2.7 2.7M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m2.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m9 0a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m-9 9a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m9 0a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
    />
  </svg>
);
export default Vault;
